import { render } from "./service_index.html?vue&type=template&id=1e6fd693&external"
const script = {}

import "@/assets/css/index.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__